// extracted by mini-css-extract-plugin
export default {"page":"Aq-z","landingBackground":"Bq-z","nonLandingBackground":"Cq-z"};